import React from 'react'
import { Badge } from 'react-bootstrap'

const IssueCounts = ({ issue }) => {
  const severityData = [
    {
      count: issue?.unresolved_count,
      label: 'Unresolved',
      icon: (
        <span
          style={{
            backgroundColor: '#E9C46A',
            borderRadius: '50%',
            display: 'inline-block',
            width: '8px',
            height: '8px',
            marginRight: '5px'
          }}
        ></span>
      )
    },
    {
      count: issue?.resolved_count,
      label: 'Resolved',
      icon: (
        <span
          style={{
            backgroundColor: '#27AB83',
            borderRadius: '50%',
            display: 'inline-block',
            width: '8px',
            height: '8px',
            marginRight: '5px'
          }}
        ></span>
      )
    },
    {
      count: issue?.ignored_count,
      label: 'Ignored',
      icon: (
        <span
          style={{
            backgroundColor: '#606060',
            borderRadius: '50%',
            display: 'inline-block',
            width: '8px',
            height: '8px',
            marginRight: '5px'
          }}
        ></span>
      )
    }
  ]

  return (
    <>
      {severityData.map((item, idx) => (
        <Badge className={`bg-white border text-primary me-1`} key={idx}>
          {item.icon}

          <span style={{ fontWeight: 500 }}>{item.count}</span>
          <span className="fw-lighter ms-1" title={item.title}>
            {item.label}
          </span>
        </Badge>
      ))}
    </>
  )
}

export default IssueCounts
